module.exports = __webpack_public_path__ + "static/media/menu.1c52e278.svg";